import React from 'react'
import Head from 'next/head'
import styled from 'styled-components'
import Link from 'next/link'
import { createResource, useResource } from '@/lib/i18n'
import dynamic from 'next/dynamic'

const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))

const resource = createResource({
  en: {
    description:
      'Enjoy direct liquid with ID card online loans from Kredit Pintar. For more information about borrowing money, visit our site',
  },
  id: {
    description:
      'Nikmati pinjaman online langsung cair KTP dari Kredit Pintar. Untuk informasi lebih lanjut mengenai pinjam uang, kunjungi situs kami',
  },
})

const SiteMap = () => {
  const { t } = useResource(resource)
  const routerList = [
    {
      href: '/',
      name: 'Home',
    },
    {
      href: '/pintar-score',
      name: 'Skor Pintar',
    },
    {
      href: '/pintar-shop',
      name: 'Skor Shop',
    },
    {
      href: '/product',
      name: 'Product',
    },
    {
      href: '/about-us',
      name: 'About Us',
    },
    {
      href: '/faq',
      name: 'FAQ',
    },
    {
      href: '/education',
      name: 'Education',
    },
    {
      href: '/attention',
      name: 'Attention',
    },
    {
      href: '/disclaimer',
      name: 'Disclaimer',
    },
    {
      href: '/career',
      name: 'Career',
    },
  ]
  return (
    <>
      <KPHead metaTitle="siteMap" />
      <Head>
        <title>Sitemap | KreditPintar</title>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation />
      <Wrapper>
        <h1>Sitemap</h1>
        <section className="location">
          {routerList.map((item) => {
            return (
              <Link key={item.href} href={item.href}>
                {item.name}
              </Link>
            )
          })}
          <a target="_blank" href="/privacy-policy">
            Privacy Policy
          </a>
          <a target="_blank" href="/terms-of-service">
            Terms Of Service
          </a>
        </section>
      </Wrapper>
      <Footer />
    </>
  )
}

export default SiteMap

const Wrapper = styled.div`
  padding: 100px 0 0 20px;
  min-height: 60vh;
  font-family: GTWalsheimPro;
  font-weight: 500;
  h1 {
    margin-bottom: 30px;
  }
  .location {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
    a {
      display: block;
      width: 300px;
      height: 30px;
      margin-bottom: 15px;
      &,
      &:hover {
        color: black;
      }
    }
  }
`
